




















import {Vue, Component, Prop} from 'vue-property-decorator'
import {Shot} from '@/store/shots'

@Component({
  name: "delete-shot-dialog",
})
export default class DeleteShotDialog extends Vue {
  @Prop() value!: {open: boolean; shot: Shot}
}
